











































































import {Vue, Component} from 'vue-property-decorator'
import {RezervniDeo} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service"
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class RezervniDelovi extends mixins(ComponentBaseMixin) {
    columns = [];
    tableOptions = {
      search: true,
      pagination: true,
      onClickRow: row => this.onClickRow(row)
    };
    rezerniDelovi = [];
    rezervniDeo = new RezervniDeo();

    grupeDelova = [];

    async created() {
        this.columns = [
            {field: 'sifra', width: 70, title: this.$i18n.t('sifra')},
            {field: 'naziv', width: 300, title: this.$i18n.t('naziv')},
            {field: 'kataloskiBroj', width: 170, title: this.$i18n.t('kataloskiBroj')},
            {field: 'grupaDelovaVozila', width: 130, title: this.$i18n.t('grupaDelova')},
            {field: 'vrstaOdrzavanja', width: 80, title: this.$i18n.t('p/c')}
        ];
        this.grupeDelova = await this.loadData(() => dataProxy.vratiGrupeDelovaVozila())();
        this.rezerniDelovi = await this.loadData(() => dataProxy.vratiRezervneDelove())();

    }

    sklopChange(grupaDelovaVozilaId) {
        if (grupaDelovaVozilaId) {
            const deoVozila = this.grupeDelova.find(x => x.id == grupaDelovaVozilaId);
            if (deoVozila) {
                this.rezervniDeo.vrstaOdrzavanja = [deoVozila.preventivnoOdrzavanje, deoVozila.korektivnoOdrzavanje].filter(val => val).join(' / ');
                this.rezervniDeo.grupaDelovaVozila = `${deoVozila.oznaka} ${deoVozila.naziv}`;
            }
        } else {
            this.rezervniDeo.grupaDelovaVozila = '';
            this.rezervniDeo.vrstaOdrzavanja = '';
        }
    }

    novRezervniDeo() {
        this.rezervniDeo = new RezervniDeo();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    async obrisiRezervniDeo() {
        const valid = await this.confirmationNeeded('da li zelite da obrisete rezervni deo');
        if (valid) {
            this.rezerniDelovi = await this.deleteData(() => dataProxy.obrisiRezervniDeo(this.rezervniDeo.id))();
            this.novRezervniDeo();
        }
    }

    async sacuvajRezervniDeo() {
        const valid = await (<any>this.$refs.form).validate();
        if (valid) {
            this.rezervniDeo = await this.saveData(() => dataProxy.sacuvajRezervniDeo(this.rezervniDeo))();
            this.rezerniDelovi = await this.loadData(() => dataProxy.vratiRezervneDelove())();
        }
    }

    onClickRow(row) {
        this.rezervniDeo = row;
    }
}
